import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import Typewriter from "./Animations/Typewriter";
import Typewriters from 'typewriter-effect';

const Header = () => {
    const [width, setWidth] = useState({
        winWidth: window.innerWidth
    });

    const location = useLocation().pathname;

    const detectSize = () => {
        setWidth({
            winWidth: window.innerWidth
        })
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        return (() => {
            window.removeEventListener('resize', detectSize)
        })
    }, [width])

    return (
        <>
            <header className="masthead" style={{ userSelect: "none" }}>
                <div className="container" id="page-top">
                    <div className="masthead-subheading img-responsive">
                        {/* Welcome To <Typewriter text="Our Studio!" delay={100} infinite /> */}
                        <Typewriters options={{ loop: true }}
                            onInit={(typewriter) => {
                                typewriter.typeString('MV Nails House')
                                    // .callFunction(() => {
                                    //     console.log('String typed out!');
                                    // })
                                    .pauseFor(500)
                                    .deleteAll()
                                    .typeString('Welcome To Our Studio!')
                                    // .callFunction(() => {
                                    //     console.log('All strings were deleted');
                                    // })
                                    .start();
                            }}
                        />
                    </div>
                    {width?.winWidth > 430 ?
                        <div className="masthead-heading text-uppercase" style={{ userSelect: "none" }}>
                            {location === '/' ? "It's Nice To Meet You" : location === '/about' ? "About Us" : location === '/services' ? "Our Services" : 'Contact Us'}
                        </div>
                        :
                        <div className="masthead-heading1 text-uppercase">
                            {location === '/' ? "It's Nice To Meet You" : location === '/about' ? "About Us" : location === '/services' ? "Our Services" : 'Contact Us'}
                        </div>
                    }

                    {/* <a className="btn btn-primary btn-xl text-uppercase" href="#services">
                        Tell Me More
                    </a> */}
                </div>
            </header>
        </>
    )
}

export default Header;